<template>
  <div>
    <l-map
      ref="mapControl"
      :zoom="zoom"
      :center="center"
      style="height: 600px; width: 100%;"
      :options="{
        minZoom: 1.5,
        zoomSnap:0.5,
      attributionControl:false,
      worldCopyJump:true}"
    >
      <l-geo-json
        v-if="show"
        ref="geojson"
        :geojson="geojson"
        :options="options"
        :options-style="styleFunction"
      />
    </l-map>
  </div>
</template>

<script>
// import { latLng } from "leaflet";
import { LMap, LGeoJson } from "vue2-leaflet";
import { icon } from "leaflet";
// import geodata from '../assets/world.geo.json';

export default {
  inject: ["eventHub"],
  name: "Example",
  components: {
    LMap,
    LGeoJson
  },
  data() {
    return {
      loading: false,
      show: true,
      enableTooltip: true,
      zoom: 0,
      center: [45, 0],
      geojson: null,
      opacity:0,
      c_result:{},
      fillColor: "#fff",
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: icon({
        iconUrl: require("../assets/pi-icon-2x.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 16]
      }),
      factor:10/10.4
    };
  },
  computed: {
    options() {
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    styleFunction() {
      const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 1.5,
          color: "#121212",
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1
        };
      };
    },
    onEachFeatureFunction() {
        const c_result = this.c_result;
        const factor = this.factor;

      if (!this.enableTooltip) {
        return () => {};
      }
      return (feature, layer) => {
        var c_throw = 0;
        var c_cross = 0;
        var estimated_pi;
        if (feature.properties.iso_a2 in c_result) {
          c_throw = c_result[feature.properties.iso_a2].throw;
          c_cross = c_result[feature.properties.iso_a2].cross;     
        }
        if (c_cross == 0) {
          estimated_pi = ''
        }else{
          estimated_pi = Math.round(2 * c_throw/c_cross*factor*1000)/1000;
        }
        layer.setStyle({
            'fillColor': data2color(c_throw,c_cross,factor)
          })
        layer.bindTooltip(
            "<h5>" +
            feature.properties.name +
            "</h5><table><tbody><tr><td>thrown:</td>" +
            "<td align='right'>"+c_throw +"</td>"+
            "</tr><tr><td>crossed:</td>" +
            "<td align='right'>"+c_cross +"</td>"+
            "</tr><tr><td>pi=" +
            estimated_pi+"</td><td></td>"+
            "</tr></tbody></table>",
          { permanent: false, sticky: true }
        );
        layer.on('mouseover', function () {
          this.setStyle({
            'fillColor': '#f38234'
          });
        });
        layer.on('mouseout', function () {
          this.setStyle({
            'fillColor': data2color(c_throw,c_cross,factor)
          });
        });

      };
    }
  },
  async created() {
    this.eventHub.$on('firestore', (msg)=> {
      this.c_result = msg.result;
    })
    
    this.loading = true;
    const response = await fetch("/geojson/world.geo.json");
    const data = await response.json();
    this.geojson = data;
    this.loading = false;
    // console.log("hello")
    
  }
};

function data2color(thrown,crossed,factor) {
  if (thrown > 0 && crossed > 0) {
    return perc2color(1-Math.abs(2*thrown/crossed*factor-3.1415926)/3.1415926)
  }else{
    return "#fff"
  }
}

function perc2color(perc) {
	var r, g = 0;
  var b = 60;
	if(perc < 0.5) {
		r = Math.round(255*0.8);
		g = Math.round(0.9*510 * perc);
	}
	else {
		g = Math.round(255*0.9);
		r = Math.round(0.8*(510 - 510 * perc));
	}
	var h = r * 0x10000 + g * 0x100 + b * 0x1;
	return '#' + ('000000' + h.toString(16)).slice(-6);
}


</script>
<style scoped>
.leaflet-container {
    background-color:rgba(255,0,0,0.0);
}
</style>
